module.exports = __webpack_public_path__ + "static/media/mobile_wd_page_area04_img_en.d437581b.png";